__turbopack_context__.v({
  "choice": "choice-tool-module__3-1gMa__choice",
  "choiceA": "choice-tool-module__3-1gMa__choiceA",
  "choiceB": "choice-tool-module__3-1gMa__choiceB",
  "choiceHint": "choice-tool-module__3-1gMa__choiceHint",
  "choiceLabel": "choice-tool-module__3-1gMa__choiceLabel",
  "choiceText": "choice-tool-module__3-1gMa__choiceText",
  "choices": "choice-tool-module__3-1gMa__choices",
  "counter": "choice-tool-module__3-1gMa__counter",
  "eyebrow": "choice-tool-module__3-1gMa__eyebrow",
  "muted": "choice-tool-module__3-1gMa__muted",
  "next": "choice-tool-module__3-1gMa__next",
  "reset": "choice-tool-module__3-1gMa__reset",
  "result": "choice-tool-module__3-1gMa__result",
  "selected": "choice-tool-module__3-1gMa__selected",
  "tool": "choice-tool-module__3-1gMa__tool",
  "topbar": "choice-tool-module__3-1gMa__topbar",
});
